import React from "react";
import dashboardImage from '../assets/images/dashboard.png';
import posBillingImage from '../assets/images/billing.png';
import transactionsImage from '../assets/images/transactions.png';
import reportsImage from '../assets/images/reports.png';
import invoice from '../assets/images/invoice.png';
import restaruntBilling from '../assets/images/pBilling.png'

const Features = () => {
    const features = [
        {
            title: "Comprehensive Dashboard Insights",
            description: "Monitor your business performance with a comprehensive dashboard.",
            imageUrl: dashboardImage,
        },
        {
            title: "POS Billing",
            description: "Quickly process sales and generate bills with ease.",
            imageUrl: posBillingImage,
        },
        {
            title: "POS Billing Restaurant Theme",
            description: "Quickly process sales and generate bills with ease.",
            imageUrl: restaruntBilling,
        },
        {
            title: "Transactions Management",
            description: "Keep track of all transactions to ensure accurate records.",
            imageUrl: transactionsImage,
        },
        {
            title: "Professional Invoices",
            description: "Create and print professional invoices for your business.",
            imageUrl: invoice, // Dummy image URL
        },
        {
            title: "Generate Detailed Reports",
            description: "Analyze business performance with detailed reports.",
            imageUrl: reportsImage, // Dummy image URL
        },
    ];

    return (
        <section id="features" className="py-12  overflow-hidden">
            <div
                className="container mx-auto px-4 mt-8"
                data-aos="fade-up"
                data-aos-duration="2000"
            >
                <h2 className="text-3xl font-bold text-primary text-center">
                    Explore the Power of INVETIX POS Features
                </h2>

                <div className="mt-8 space-y-12">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className={`flex flex-col md:flex-row items-center ${index % 2 === 0
                                ? "md:flex-row"
                                : "md:flex-row-reverse"
                                } gap-8 md:py-12`}
                            data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                        // data-aos-delay="200"
                        >
                            {/* Image Section */}
                            <div className="w-full md:w-8/12">
                                <img
                                    src={feature.imageUrl}
                                    alt={feature.title}
                                    className="rounded-lg  w-full h-auto"
                                    data-aos="zoom-in"
                                // data-aos-delay="400"
                                />
                            </div>

                            {/* Description Section */}
                            <div className="w-full md:w-4/12">
                                <h3
                                    className="text-2xl font-bold text-primary"
                                    data-aos="fade-up"
                                    data-aos-delay="200"
                                >
                                    {feature.title}
                                </h3>
                                <p
                                    className="text-gray-700 mt-4"
                                    data-aos="fade-up"
                                    data-aos-delay="400"
                                >
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Features;